import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'

/**
 * useFiscalStatus tells the UI whether the tenant has a real fiscal
 * jurisdiction configured (FBR / PRAL POS / FBR DI / LOCAL_BRIDGE) so it
 * can label the refund flow appropriately:
 *
 *   • enabled = true  → "Credit Note" copy, FBR submission, IRN/QR shown
 *   • enabled = false → "Refund" copy, no FBR submission, no IRN/QR
 *
 * Mirrors backend/internal/fiscal/config.go > LoadedTaxConfig.IsEnabled().
 * Cached aggressively because fiscal config rarely changes and an
 * authority flip is an admin-driven event that justifies a manual reload.
 */
export function useFiscalStatus(): { enabled: boolean; authority: string } {
  const { data } = useQuery({
    queryKey: ['fiscal', 'config'],
    queryFn: () => apiClient.getFiscalConfig(),
    staleTime: Infinity,
  })
  const authority = (data?.data?.authority ?? '').toString().trim().toUpperCase()
  const enabled = authority !== '' && authority !== 'NONE' && authority !== 'MOCK'
  return { enabled, authority }
}
